// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 11-observability.md#logs
// @greenlight-spec: 17-code-organization.md
import { initContract } from '@ts-rest/core';
import { LogsPageSchema, LogsQuerySchema, LogsStreamQuerySchema } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
export const logsContract = c.router({
    tail: {
        method: 'GET',
        path: '/api/apps/:id/logs',
        pathParams: AppIdParamsSchema,
        query: LogsQuerySchema,
        responses: {
            200: LogsPageSchema,
            ...errorResponses,
        },
        summary: 'Read a bounded, cursor-paginated window of an app pod’s logs live from the kubelet. The dashboard’s Monitoring tab polls this endpoint cursor-forward when its live stream is unavailable.',
    },
    stream: {
        method: 'GET',
        path: '/api/apps/:id/logs/stream',
        pathParams: AppIdParamsSchema,
        query: LogsStreamQuerySchema,
        responses: {
            200: c.otherResponse({ contentType: 'text/event-stream', body: c.type() }),
            ...errorResponses,
        },
        summary: 'Follow an app pod’s logs live from the kubelet as Server-Sent Events for the dashboard’s Monitoring tab. Each `line` event carries the row and a tail cursor positioned after it; an `end` event precedes every server-side close. Authenticates with the session cookie. Not an MCP surface: agents read logs with getLogs.',
    },
});
//# sourceMappingURL=logs.js.map